import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.452 26.37 8.59-9.665-8.59-9.665-1.495 1.33 7.41 8.335-7.41 8.335z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcChevronRight;
